import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "babel-polyfill";
import axios from "axios";
import VueAxios from "vue-axios";
import MaterialIcons from "material-design-icons/iconfont/material-icons.css";
import VueQRCodeComponent from "vue-qrcode-component";
import Notifications from "vue-notification";
import SocialSharing from "vue-social-sharing";

Vue.use(SocialSharing);
Vue.use(Notifications);
Vue.use(require("vue-moment"));
Vue.use(VueAxios, axios);
Vue.component("qr-code", VueQRCodeComponent);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  data() {
    return {
      messagePop: false,
      message: "welcome",
      loader: false
    };
  },
  methods: {
    notify(type,message){
      this.$notify({
        group: 'foo',
        title: 'Important message',
        text: message,
        duration:5000,
        type:type
      })
    },
    notification(type,message){
      this.$notify({
        group: 'foo',
        title: 'Important message',
        text: message,
        duration:5000,
        type:type
      })
    },
    alert(msg) {
      let vm = this;
      vm.message = msg;
      vm.messagePop = true;
    }
  },
  render: h => h(App)
}).$mount("#app");
